/* eslint-disable no-console */
import { apiClient, handleResponse } from './axios';

async function getSkills() {
  try {
    const response = await apiClient.get('/skill');
    const skills = await handleResponse(response);
    return skills;
  } catch (err) {
    return console.error(err);
  }
}

const skillServices = {
  getSkills,
};

export default skillServices;
